var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import merge from 'deepmerge';
import configureTooltip from '../tooltip/main';
import chartUtils from '../../../utils/chart-utils';

var buildGaugeConfiguration = function buildGaugeConfiguration(gaugeConfig, seriesConfig, seriesDataObj, customConfig) {
    var dataValue = seriesDataObj["Solid Gauge"][0][gaugeConfig.ValueField];
    var seriesType = 'gauge';
    var ValueFormat = seriesConfig.ValueFormat,
        CurrencySymbol = seriesConfig.CurrencySymbol,
        BaseFormat = seriesConfig.BaseFormat,
        ShowLabels = seriesConfig.ShowLabels;


    var text = null;
    var valueName = seriesConfig.ValueField;
    var maxTitleLength = 16;

    switch (seriesConfig.AggregationType) {
        case 2:
            text = '# ' + valueName;
            break;
        case 3:
            text = 'Average ' + valueName;
            break;
        case 4:
            text = 'Unique # ' + valueName;
            break;
        default:
            text = 'Total ' + valueName;
            break;
    }

    text = text && text.length > maxTitleLength ? text.substring(0, maxTitleLength) + "..." : text;

    return merge({
        innerRadius: gaugeConfig.GaugeType === "SolidGauge" ? '50%' : undefined,
        data: [dataValue],
        dataLabels: {
            formatter: function formatter() {
                var labelContent = '<div> <span style="font-size:15px;font-weight:bold">' + text + '</span><br/>\n                                    <span style="font-size:15px;font-weight:bold">' + chartUtils.format(this.y, ValueFormat, CurrencySymbol, null, BaseFormat) + '</span></div>';
                var label = '';
                if (ShowLabels) label = labelContent;
                return label;
            },
            verticalAlign: 'middle',
            style: {
                "fontSize": "20px"
            }
        },
        tooltip: configureTooltip(seriesType, _extends({}, seriesConfig, { ValueFormat: ValueFormat, CurrencySymbol: CurrencySymbol }))
    }, customConfig);
};

var buildGaugeTargetLineConfiguration = function buildGaugeTargetLineConfiguration(gaugeConfig, seriesConfig, seriesDataObj) {
    var taregtValue = seriesDataObj["Solid Gauge"][0][gaugeConfig.TargetField];
    var targetColor = gaugeConfig.TargetLineColor;
    var seriesType = 'gauge_targetline';
    var ValueFormat = seriesConfig.ValueFormat,
        CurrencySymbol = seriesConfig.CurrencySymbol;


    return {
        data: [taregtValue],
        type: 'gauge',
        dial: {
            baseLength: "100%",
            radius: "100%",
            rearLength: "-50%",
            backgroundColor: targetColor
        },
        dataLabels: {
            enabled: false
        },
        tooltip: configureTooltip(seriesType, _extends({}, seriesConfig, { ValueFormat: ValueFormat, CurrencySymbol: CurrencySymbol }))
    };
};

export { buildGaugeConfiguration, buildGaugeTargetLineConfiguration };